import { Paper, Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ContentType } from 'recharts/types/component/Tooltip';

import { statusChartcolorsMap } from '../../utils/chart-colors';

import classes from './custom-tooltip.module.css';

export const CustomTooltip: ContentType<string, string> = (props) => {
  const { t } = useTranslation();

  if (props.active && props.payload && props.payload.length) {
    return (
      <Paper p="lg" shadow="sm" withBorder>
        <Group align="center" gap="xs" wrap="nowrap">
          <span
            className={classes.dot}
            style={{
              backgroundColor:
                statusChartcolorsMap[
                  props.payload[0].name as keyof typeof statusChartcolorsMap
                ],
            }}
          ></span>
          <Text
            style={{
              whiteSpace: 'nowrap',
            }}
          >
            {t(`common.${props.payload[0].name}`)} : {props.payload[0].value}{' '}
            {props.payload[0].payload.unit}
          </Text>
        </Group>
      </Paper>
    );
  }

  return null;
};

export default CustomTooltip;
